import maps from 'src/data/maps.json';
import { Screen } from 'src/types/Screen';

export const getMediaBreakpointValue = (screen: Screen) => {
    let breakpoint: string | number = 0;
    switch (screen) {
        case 'xs':
            breakpoint = 0;
            break;
        case 'mobile':
            breakpoint = '280px';
            break;
        default:
            breakpoint = maps.breakpoints[screen];
            break;
    }
    return `(min-width: ${breakpoint})`;
};

const getBreakpointValues = (screen: Screen) => {
    if (screen === 'mobile') {
        return '280px';
    }

    if (screen === 'xs') {
        return 0;
    }

    return maps.breakpoints[screen];
};

export default getBreakpointValues;
